import React from 'react';
import { Link } from 'react-router-dom';
import withCards, { CardContext } from 'hoc/withCards';
import ListFilter from 'components/common/list-filter/ListFilter';
import { fetchDispensaDisciplina } from 'services/curricula-services';
import StudentCurriculumInputAsync from 'components/informed-inputs/StudentCurriculumInputAsync';

const Card = ({ className, id, curriculo, aluno, disciplina }) => {
  return (
    <Link
      to={`/dispensas/disciplinas/${id}/edit`}
      className={`${className} card-100 card-body`}
    >
      <div className="d-flex justify-space-between">
        <p className="semi-bold brown text-underline">
          Dispensa de Disciplina #{id}
        </p>
      </div>
      <div className="d-flex align-items-center">
        <div className="mb-1 mt-1">
          <span className="brown">Curriculo:</span> {curriculo}
        </div>
      </div>
      <div className="d-flex align-items-center">
        <div className="mb-1">
          <span className="brown">Aluno:</span> {aluno}
        </div>
      </div>
      <div className="d-flex align-items-center">
        <div className="mb-2">
          <span className="brown">Disciplina:</span> {disciplina}
        </div>
      </div>
    </Link>
  );
};

const DispensaDisciplinaListPage = ({ renderLoading, onChangeForm }) => {
  return (
    <CardContext.Consumer>
      {({ cards }) => (
        <>
          <ListFilter
            type="text"
            hasSearchInput={false}
            onValueChange={(e) =>
              onChangeForm({
                ...e,
                student_curriculum: e?.student_curriculum?.id,
              })
            }
            numberOfColumns={1}
          >
            <StudentCurriculumInputAsync
              field="student_curriculum"
              name="student_curriculum"
              label="Currículo x Aluno"
              getOptionLabel={(option) =>
                `${option.student.name} - ${option.curriculum.name}`
              }
              getOptionValue={(option) => option.id}
            />
          </ListFilter>
          <div className="card-deck">
            {renderLoading() ||
              cards.map((card) => (
                <Card
                  key={card.id}
                  id={card.id}
                  nome={card.nome}
                  curriculo={card.student_curriculum.curriculum.name}
                  aluno={card.student_curriculum.student.name}
                  disciplina={card.completed_discipline_name}
                />
              ))}
          </div>
        </>
      )}
    </CardContext.Consumer>
  );
};

export default withCards({
  fetch: fetchDispensaDisciplina,
  title: 'Lista de Dispensas de Disciplinas',
  paginated: true,
  noResultsText: 'Nenhuma dispensa de disciplina foi encontrada.',
})(DispensaDisciplinaListPage);
